import React from "react"
import Button from "storybookComponents/Button";
import IconComponent from "components/IconComponent";
import { DeleteIcon, MandatoryIcon } from "icons"
import SortableList from "components/Sortable/SortableList";
import SortableItem from "components/Sortable/SortableItem";
import SelectField from "./selectField"
import Tooltip from "storybookComponents/Tooltip"
import {
  filterOption,
} from "./utils"



const FormContent = ({ values, arrayValues, classes, hylyFormFields, ...props }) => {
  const renderListItem = (value, index) => {
    const options = filterOption(hylyFormFields, values.fieldArray, index);
    const isDefault = value.fieldDetails.fieldId === "hyFirstName" || value.fieldDetails.fieldId === "hyLastName" || value.fieldDetails.fieldId === "hyEmail" || value.fieldDetails.fieldId === "hyPhone"
    const handleDelete = () => {
      arrayValues.remove(index);
    }
    const handleMarkRequired = () => {
      props.setFieldValue(`fieldArray.${index}`, {
        ...value,
        required: value.required ? false : true
      });
    }
    // return <SortableItem classes={classes} key={`${index}id`} index={index} id={`${index}id`} >
    return <div className={classes.fieldContainer} >
      {
        (value.fieldDetails) ?
          <div className={`
            ${isDefault && classes.noPointerEvents} ${classes.positionAsterisk}`
          }>
            <Tooltip placement="top" tooltip_text={value.required ? "Required Field: Check to make it optional" : "Optional Field: Check to make it required"}><IconComponent onHoverColor='#26bbed' stroke={
              value.required ? "#E75F75" : "#7e7e7e"
            } onClick={handleMarkRequired} Component={MandatoryIcon} /></Tooltip></div> :
          null
      }
      <div className={classes.selectContainer}>
        <SelectField
          value={value.fieldDetails}
          customValues={{
            placeholder: "Choose field",
            width: 220,
            mainWidth: 166,
            disableUnderline: true
          }}
          disabled={isDefault}
          index={index}
          options={options}
          setFieldValue={props.setFieldValue}
        />
      </div>
      {
        (value.fieldDetails.fieldId !== "hyFirstName" && value.fieldDetails.fieldId !== "hyLastName" && value.fieldDetails.fieldId !== "hyEmail" && value.fieldDetails.fieldId !== "hyPhone") ? <IconComponent onHoverColor='#E75F75' onClick={handleDelete} Component={DeleteIcon} /> :
          <div className={classes.divStyle}></div>
      }
    </div>
    {/* </SortableItem > */ }
  }

  const sortedList = (sortedItem) => {
    props.setFieldValue("fieldArray", sortedItem)
  }

  return (
    <div>
      {
        values.fieldArray && values.fieldArray.map(renderListItem)
      }
      {/* <SortableList
        list={values.fieldArray}
        renderItem={renderListItem}
        sortedList={sortedList}
      /> */}
      <Button
        variant="secondary"
        size="md"
        state={(values.fieldArray.length < hylyFormFields.length + 3) ? "active" : "inactive"}
        onClick={() => arrayValues.push({
          fieldDetails: ""
        })}
        className={classes.dashedButton}
      >
        + New Field
      </Button>
    </div>
  )
}


export default FormContent